import { useSelector } from 'react-redux';

import { Strings } from '@app/constants';
import { IOfficialInfoSchema } from '../types';
import { DetailsCard } from '@app/components/card';
import { selectRoleState } from '@app/modules/role';
import { selectEmployeesState } from '../selectors';

interface Props {
  userData: IOfficialInfoSchema;
}

export const OfficialInfo = ({ userData }: Props) => {
  const roleState = useSelector(selectRoleState);
  const roles = roleState.data?.records;
  const employeeState = useSelector(selectEmployeesState);
  const managers = employeeState.data?.records;

  const managerNames = userData?.managerId
    ?.map((id) => managers?.find((manager) => manager.id === Number(id))?.firstName)
    .filter(Boolean)
    .join(', ');

  const fields = [
    Strings.field.officialEmail,
    Strings.field.joinDate,
    Strings.role.role,
    Strings.department.department,
    Strings.designation.designation,
    Strings.addEmployee.manager,
  ];

  const data = [
    userData?.email ?? 'NA',
    userData?.joiningDate ? userData?.joiningDate : 'NA',
    roles?.find((role) => role.id === userData?.roleId)?.name ?? 'NA',
    userData?.department ?? 'NA',
    userData?.designation ?? 'NA',
    managerNames || 'NA',
  ];

  return (
    <DetailsCard
      title={Strings.profile.officialInformation}
      fields={fields}
      data={data}
      height={'270px'}
      iconImg={'ic_official'}
    />
  );
};
